import styled from 'styled-components'
import colorsOptions from '../stories/fundamentals/colors-styles/constants'
import {
  textStyleSizeOptions,
  textStyleSizeStyleOptions,
  textStyleWeightOptions,
  textStyleWeightStyleOptions
} from '../stories/fundamentals/text-styles/constants'

export const CopyModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 1rem 1.875rem;
`

export const ProjectTitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 0 1.5rem;
  border-bottom: 1px solid ${colorsOptions.greys['grey-20']};
`

export const CopyModalContent = styled.div`
  display: flex;
  padding: 1.5rem 1rem;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 2rem;
  align-self: stretch;

  border-radius: 16px;
  border: 1px solid ${colorsOptions.greys['grey-20']};
  background: ${colorsOptions.greys.white};
`

export const CopyModalContentTitle = styled.p`
  display: flex;
  padding: 1rem 1rem 0.5rem 0;
  align-items: center;
  gap: 0.5rem;

  overflow: hidden;
  color: ${colorsOptions.greys['grey-90']};
  font-variant-numeric: lining-nums proportional-nums;
  text-overflow: ellipsis;

  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-L']]};
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-700']]};
  line-height: 20.8px; /* 130% */
  letter-spacing: 0.2px;
`

export const CopyModalTextInputContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 1.5rem;
  align-self: stretch;
`

export const CopyModalIncludeContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  gap: 0.5rem;
  width: 100%;

  > div {
    flex: 1 1 0;
    min-width: 0;
  }
`

export const CopyModalIncludeItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  width: 100%;
  min-height: 40px;
`

export const CopyModalIncludeRow = styled.div`
  display: flex;
  flex: 1 1 auto;
  align-items: center;
  gap: 0.75rem;
  min-width: 0;
`

export const CopyModalIncludeItemContent = styled.div`
  display: flex;
  gap: 0.75rem;
  flex: 1;
`
export const CopyModalIncludeItemText = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-width: 0;
`

export const CopyModalIncludeItemTitle = styled.div`
  color: ${colorsOptions.greys['grey-100']};
  font-variant-numeric: lining-nums proportional-nums;

  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-R']]};
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-600']]};
  line-height: 18.2px; /* 130% */
  letter-spacing: 0.2px;
`

export const CopyModalIncludeItemDescription = styled.div`
  color: ${colorsOptions.greys['grey-70']};
  font-variant-numeric: lining-nums proportional-nums;

  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-S']]};
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-500']]};
  line-height: 15.6px; /* 130% */
  letter-spacing: 0.2px;
`

export const CopyModalMainContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  align-self: stretch;
`

export const CopyModalTabsContent = styled.div`
  width: 100%;
  padding: 0 1rem;
`

export const CopyMembersAvatar = styled.img`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  object-fit: contain;
`

export const CopyMembersTabsContent = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${colorsOptions.greys.white};
  border: 1px solid ${colorsOptions.greys['grey-20']};
  border-top: none;
  border-end-start-radius: 16px;
  border-end-end-radius: 16px;
  overflow: hidden;
`

export const CopyMembersTabsSearchContainer = styled.div`
  padding: 0.5rem 1rem;
  border-bottom: 1px solid ${colorsOptions.greys['grey-20']};
`

export const CopyMembersTabMembersContainer = styled.div`
  max-height: 350px;
  min-height: 350px;
  overflow-y: auto;
`

export const CopyMembersTabEmptyMembersContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  max-height: 400px;
  min-height: 400px;
  padding: 1rem;
`

export const CopyProjectTabTitle = styled.div`
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-S']]};
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-700']]};
`

export const StaticBannerContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`
